import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';
import { func, array, string } from 'prop-types';

import { Modal, CheckIcon, XMarkIcon } from '@snapask/common-components';

import PurchaseModalTheme from '@dragonfruit/styles/modalTheme/checkout.scss';

import styles from './LearnMoreModal.scss';
function LearnMoreModal({ onClose, title, infoList }) {
  const renderLearnMoreText = learnMore => (
    <li className={styles.listItem}>
      <h3 className={styles.title}>
        <span className={styles.check}>
          <CheckIcon width={16} height={16} className={styles.checkIcon} />
        </span>
        {learnMore.title}
      </h3>
      <p className={styles.content}>{learnMore.description}</p>
    </li>
  );

  return ReactDOM.createPortal(
    <Modal onClose={onClose} theme={PurchaseModalTheme}>
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.cross}>
            <XMarkIcon
              width={24}
              height={24}
              className={styles.closeIcon}
              onClick={onClose}
            />
          </div>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <div className={styles.body}>
          <ul className={styles.descriptionList}>
            {infoList.map(renderLearnMoreText)}
          </ul>
        </div>
      </div>
    </Modal>,
    document.getElementById('modal')
  );
}
LearnMoreModal.propTypes = {
  infoList: array.isRequired,
  t: func.isRequired,
  title: string.isRequired,
  onClose: func.isRequired,
};

export default translate('purchase')(LearnMoreModal);



// WEBPACK FOOTER //
// ./app/components/LearnMoreModal/LearnMoreModal.jsx